/* global common */
import {
  libInit,
  prefetchImageFromSource,
  sendGoogleEvent,
  isObjectFitSupported,
  byWindowAction, sendAmplitudeEvent,
} from '@html/_common/utils';

export default function HeroImageGalleryGrid(tdpEventCategory, imageGalleryLightboxManager) {
  const $mainHeroImageWrapper = $('.js-ao-tour-hero-image-wrapper');
  const $gridGalleryImageItem = $('.js-ao-tour-hero-image-gallery-item');
  const $gridGalleryReviewItem = $('.js-ao-tour-hero-image-gallery-review ');

  let imageUrls = null;
  let currentImageIndex = 0;

  this.common = typeof sendGoogleEvent !== 'undefined' ? {
    prefetchImageFromSource,
    sendGoogleEvent,
    isObjectFitSupported,
    byWindowAction,
    lib: { init: libInit },
  } : common;

  this.initiate = (newImageUrls) => {
    const preparedImageUrls = this.setupImageUrls(newImageUrls);

    this.setupClickEvents();
    this.initiateGalleryPopup(preparedImageUrls);
  };

  this.initiateGalleryPopup = (imageSources) => {
    imageGalleryLightboxManager.createNewImageGallery(imageSources, {
      openElementSelector: '.js-ao-tour-modal-trigger',
      startingIndex: () => this.getCurrentIndex(),
      lowerResolutionImageSize: '232x150',
      higherResolutionImageSize: '1500x800',
      googleEvents: {
        category: tdpEventCategory,
        eventGalleryName: 'Hero',
        actionVariations: [
          {
            className: 'js-ao-tour-hero-image-wrapper',
            action: 'With image click',
          },
        ],
      },
    });
  };

  this.setupImageUrls = (additionalImageUrls) => {
    const startingImageUrl = $mainHeroImageWrapper.data('starting-image-url');

    imageUrls = [startingImageUrl, ...additionalImageUrls];
    return imageUrls;
  };

  this.setupClickEvents = () => {
    $gridGalleryImageItem.on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const $clickedElement = $(event.currentTarget);
      currentImageIndex = $clickedElement.data('image-count');
      $('.js-ao-tour-modal-trigger').click();

      sendAmplitudeEvent({
        ampEventName: 'tdp_hero_gallery_clicked',
        tdp_hero_gallery: 'Multi-media',
        tdp_hero_gallery_type_clicked: 'Operator Photo',
        tdp_hero_gallery_position: currentImageIndex + 1,
      });
    });

    $gridGalleryReviewItem.on('click', () => {
      sendAmplitudeEvent({
        ampEventName: 'tdp_hero_gallery_clicked',
        tdp_hero_gallery: 'Multi-media',
        tdp_hero_gallery_type_clicked: 'Customer Review',
      });
    });
  };

  this.getCurrentIndex = () => currentImageIndex;
}
